export default function getWebGLRendererInfo() {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('webgl');
    if (!context) return {};

    const debugContext = context.getExtension('WEBGL_debug_renderer_info');
    if (!debugContext) return {};

    return {
        vendor: context.getParameter(debugContext.UNMASKED_VENDOR_WEBGL),
        renderer: context.getParameter(debugContext.UNMASKED_RENDERER_WEBGL),
    };
}
